package acupoint.components

import antd.card.card
import antd.grid.col
import antd.grid.row
import antd.message.message
import antd.typography.paragraph
import antd.typography.title
import antd.radio.radio
import antd.radio.radioGroup
import com.jingfangpai.common.orm.mapping.Acupoint
import external.pinyin.Pinyin
import kotlinext.js.js
import react.*
import react.dom.div
import acupoint.containers.AcupointListPageContext
import react.router.dom.useHistory
import urlBase
import kotlinx.browser.document
import kotlinx.html.id
import kotlinx.html.js.onClickFunction
import kotlinx.html.onClick
import react.dom.attrs
import react.dom.jsStyle

external interface AcupointListProps : RProps {

}

val AcupointList = functionalComponent<AcupointListProps> { props ->

    val ctx = useContext(AcupointListPageContext)
    val history = useHistory()

    val (acupointList, setAcupointList) = useState(listOf<Acupoint>())
    val (sortType, setSortType) = useState("pinyin") // "pinyin" or "meridian"

    fun getAcupointList() {
        ctx.getAcupointList({ resp ->
            if (resp.ok()) {
                setAcupointList(resp.data ?: listOf())
            } else {
                message.error("获取穴位列表失败:${resp.message}")
            }
        }, {
            message.error("获取穴位列表失败:${it.message}")
        })
    }

    useEffectOnce {
        getAcupointList()
    }

    // Group and sort acupoints based on sortType
    val groupedAcupoints = when (sortType) {
        "pinyin" -> {
            val grouped = acupointList.groupBy { acupoint: Acupoint ->
                val name = acupoint.name?.name ?: ""
                if (name.isNotEmpty()) {
                    try {
                        val spell = Pinyin.getSpell(name, null, null)
                        console.log(spell)
                        if (spell.startsWith("[")) {
                            val spells = spell.replace("[", "").replace("]", "").split(",")
                            spells[0].substring(0, 1).uppercase() // 默认第1个
                        } else {
                            spell.substring(0, 1).uppercase()
                        }
                    } catch (e: Exception) {
                        console.error("Pinyin conversion failed:", e)
                        name.substring(0, 1).uppercase()
                    }
                } else "#"
            }
            grouped.toList().sortedBy { it.first }.toMap().mapValues { it.value.sortedBy { acu -> acu.name?.name ?: "" } }
        }
        "meridian" -> {
            val grouped = acupointList.groupBy { acupoint: Acupoint ->
                acupoint.meridianName ?: "其他"
            }
            grouped.toList().sortedBy { it.first }.toMap().mapValues { it.value.sortedBy { acu -> acu.name?.name ?: "" } }
        }
        else -> mapOf("所有" to acupointList.sortedBy { it.name?.name ?: "" })
    }

    div("AcupointList") {
        card {
            attrs {
                title = "穴位列表"
            }
            div {
                attrs.jsStyle  = js {
                    position = "sticky"
                    top = "0"
                    backgroundColor = "white"
                    zIndex = 1000
                    paddingBottom = "10px"
                }
                radioGroup {
                    attrs {
                        value = sortType
                        onChange = {
                            setSortType(it.target.value as String)
                        }
                    }
                    radio {
                        attrs {
                            value = "pinyin"
                        }
                        +"按拼音排序"
                    }
                    radio {
                        attrs {
                            value = "meridian"
                        }
                        +"按经络排序"
                    }
                }
                // Index bar
                div {
                    attrs.jsStyle = js {
                        display = "flex"
                        flexWrap = "wrap"
                        gap = "5px"
                        marginTop = "10px"
                    }
                    groupedAcupoints.keys.sorted().forEach { key ->
                        div {
                            this.attrs {
                                jsStyle = js {
                                    cursor = "pointer"
                                    padding = "5px 10px"
                                    backgroundColor = "#f0f0f0"
                                    borderRadius = "4px"
                                    fontSize = "14px"
                                }
                                onClickFunction = {
                                    val element = document.getElementById("group-$key")
                                    element?.scrollIntoView(js {
                                        behavior = "smooth"
                                        block = "start"
                                    })
                                }
                            }
                            +key
                        }
                    }
                }
            }
            if (acupointList.isEmpty()) {
                div {
                    +"暂无数据"
                }
            } else {
                groupedAcupoints.forEach { (groupKey, acupoints) ->
                    div {
                        attrs {
                            id = "group-$groupKey"
                            jsStyle = js {
                                marginBottom = "20px"
                            }
                        }
                        title {
                            attrs {
                                level = 4
                            }
                            +groupKey
                        }
                        row {
                            acupoints.forEach { acupoint ->
                                col {
                                    attrs {
                                        span = 6
                                    }
                                    card {
                                        attrs{
                                            hoverable = true
                                            onClick = {
                                                if (!acupoint.id.isNullOrBlank()) {
                                                    history.push("$urlBase/learning/acupoint/detail/${acupoint.id}")
                                                }
                                            }
                                        }
                                        div {
                                            // 穴位名称
                                            title {
                                                attrs {
                                                    level = 4
                                                }
                                                +(acupoint.name?.name ?: "")
                                            }
                                            // 定位
                                            if (!acupoint.location.isNullOrBlank()) {
                                                div {
                                                    +"定位："
                                                    paragraph {
                                                        attrs {
                                                            ellipsis = true
                                                        }
                                                        +(acupoint.location ?: "")
                                                    }
                                                }
                                            }
                                            // 主治
                                            if (!acupoint.indications.isNullOrBlank()) {
                                                div {
                                                    +"主治："
                                                    paragraph {
                                                        attrs {
                                                            ellipsis = true
                                                        }
                                                        +(acupoint.indications ?: "")
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
